import { CFC } from "@api/types/cypress";
import ProfileAttribute from "@api/types/profile-attribute";
import React from "react";

import BoatingCardIcon from "@components/EnrolledCourseRegistrationForm/BoatingCardIcon";
import WarningIcon from "@components/EnrolledCourseRegistrationForm/WarningIcon";

const InlineText: CFC<{ data: ProfileAttribute }> = ({ data }) => (
  <React.Fragment>
    <div className={`${data.fieldName} ${data.style}`}>
      {data.fieldName === "warning" && (
        <div>
          <WarningIcon />
        </div>
      )}
      <span>{data.value}</span>
      {data.fieldName === "warning" && (
        <div>
          <BoatingCardIcon />
        </div>
      )}
    </div>
    <style jsx>{`
      .formheader {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 24px;
      }

      .small {
        font-size: 13px;
        color: #181818;
      }

      .H2 {
        font-weight: bold;
        font-size: 18px;
      }

      .formdetail {
        margin-bottom: 0.5rem;
      }

      .nameHeader,
      .nameHeader2 {
        text-align: center;
      }

      .nameHeader2 {
        padding-bottom: 0.5rem;
        border-bottom: 1px solid #ccc;
      }

      .warning {
        color: red;
        margin: 1rem 0;
        padding: 1rem;
        border: 1px solid #ccc;
        display: grid;
        grid-template-columns: 1fr;
      }

      .warning :global(svg) {
        display: none;
      }

      .warning span {
        margin: auto 0;
      }

      @media screen and (min-width: 1380px) {
        .warning {
          grid-template-columns: 1fr 14fr 1fr;
          grid-column-gap: 1rem;
        }

        .warning :global(svg) {
          display: block;
        }
      }
    `}</style>
  </React.Fragment>
);

export default InlineText;
